import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions';

export default (build: EndpointBuilder<any, any, any>) =>
  build.query<Response, QueryParams>({
    query: (params) => {
      const queryParams = new URLSearchParams();

      if (params.search) queryParams.append('search', params.search);
      if (params.status) queryParams.append('status', params.status);
      if (params.created_by) queryParams.append('created_by', params.created_by);
      if (params.per_page) queryParams.append('per_page', params.per_page.toString());
      if (params.page) queryParams.append('page', params.page.toString());
      if (params.date_from) queryParams.append('date_from', params.date_from);
      if (params.date_to) queryParams.append('date_to', params.date_to);

      return {
        url: `v5/link/list${queryParams.toString() ? `?${queryParams.toString()}` : ''}`,
        method: 'GET',
      };
    },
  });

export interface QueryParams {
  search?: string;
  status?: 'active' | 'expired';
  created_by?: 'system' | 'admin';
  per_page?: number;
  page?: number;
  date_from?: string;
  date_to?: string;
}

export interface DynamicLink {
  id: number;
  title: string;
  short_url: string;
  target_type: string;
  target_id: number;
  created_at: string;
  expiry_date: string | null;
  status: 'active' | 'expired';
  source: string;
  details: LinkDetail[];
}

export interface LinkDetail {
  platform: string;
  user_agent: string;
  referrer: string;
  browser: string;
  device_type: string;
  geo_location: string;
  language: string;
  user_id: number;
}

interface Response {
  data: DynamicLink[];
  meta?: {
    current_page: number;
    last_page: number;
    total: number;
    per_page: number;
  };
}
